import * as tslib_1 from "tslib";
import { sleep } from '@ivy/fts/utils';
import { Component, Vue, Prop } from 'vue-property-decorator';
let LuckSquare = class LuckSquare extends Vue {
    constructor() {
        super(...arguments);
        this.currentIndex = -1; // 当前转动到哪个位置，起点位置
        this.count = 8; // 总共有多少个位置
        this.timer = 0; // 每次转动定时器
        this.speed = 200; // 初始转动速度
        this.times = 0; // 转动次数
        this.cycle = 50; // 转动基本次数：即至少需要转动多少次再进入抽奖环节
        this.prize = -1; // 中奖位置
        this.click = true;
        this.rewardId = -1; // 中奖ID
        this.index = 0;
    }
    get filterRewards() {
        return (this.rewards || []).filter((item, i) => i <= 7);
    }
    _getStyle(item) {
        return { backgroundImage: `url(${item.pic_url})` };
    }
    async luckySquareClick() {
        this.$emit('get-prize', this);
    }
    // 开始抽奖
    async startDraw() {
        if (!this.click)
            return;
        this.speed = 200;
        this.click = false;
        this.startRoll();
    }
    // 开始转动
    async startRoll() {
        this.times += 1; // 转动次数
        this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
        // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
        if (this.times > this.cycle + 10 && this.prize === this.currentIndex) {
            clearTimeout(this.timer); // 清除转动定时器，停止转动
            this.prize = -1;
            this.times = 0;
            this.click = true;
            this.$emit('game-over');
            await sleep(1000);
        }
        else {
            if (this.times < this.cycle) {
                this.speed -= 10; // 加快转动速度
            }
            else if (this.times === this.cycle) {
                this.prize = this.prizeIndex;
                if (this.prize > 7) {
                    this.prize = 7;
                }
                console.log(`中奖位置${this.prize}`);
            }
            else if (this.times > this.cycle + 10 &&
                ((this.prize === 0 && this.index === 7) ||
                    this.prize === this.currentIndex + 1)) {
                this.speed += 110;
            }
            else {
                this.speed += 20;
            }
            if (this.speed < 40) {
                this.speed = 40;
            }
            this.timer = setTimeout(this.startRoll, this.speed);
        }
    }
    // 每一次转动
    oneRoll() {
        let currentIndex = this.currentIndex; // 当前转动到哪个位置
        const count = this.count; // 总共有多少个位置
        currentIndex += 1;
        if (currentIndex > count - 1) {
            currentIndex = 0;
        }
        this.currentIndex = currentIndex;
    }
};
tslib_1.__decorate([
    Prop()
], LuckSquare.prototype, "rewards", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], LuckSquare.prototype, "activeOver", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], LuckSquare.prototype, "isOver", void 0);
tslib_1.__decorate([
    Prop({ default: 0 })
], LuckSquare.prototype, "prizeIndex", void 0);
tslib_1.__decorate([
    Prop()
], LuckSquare.prototype, "drawBackground", void 0);
LuckSquare = tslib_1.__decorate([
    Component
], LuckSquare);
export default LuckSquare;
